<template>
  <v-dialog v-model="formValue" v-bind="$attrs">
    <v-card>
      <div class="text-xs-center title-icon">
        <v-icon large class="warning--text">warning</v-icon>
      </div>
      <v-card-title class="headline title">
        <slot name="title"></slot>
      </v-card-title>
      <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
      <v-card-text>
        <slot name="text"></slot>
      </v-card-text>
      <v-card-actions>
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        formValue: false,
      }
    },
    watch: {
      value(v) {
        this._updateFormValue(v)
      },
      formValue(v) {
        this._emitChange(v)
      },
    },
    methods: {
      _updateFormValue(v) {
        this.formValue = v
      },
      _emitChange(v) {
        this.$emit('input', v)
      },
      close() {
        this._emitChange(false)
      },
    },
    mounted() {
      this._updateFormValue(this.value)
    },
  }
</script>

<style scoped>
  .title-icon {
    padding-top: 6px;
  }

  .title {
    justify-content: center;
  }
</style>